module.exports = {"title":"Export","exportXls":"Export portfolia do XLS"}